<template>
  <v-card
    class="d-flex pa-2 flex-column align-center justify-center"
    outlined
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'fit-content',
    }"
    elevation="2"
  >
    <div
      class="d-flex flex-column justify-center align-center"
      :style="{
        'text-align': 'center',
        width: '70%',
        padding: '50px 0px 50px 0px',
      }"
    >
      <h3>Pilih Tipe Merchant</h3>
      <p>
        Silahkan pilih tipe merchant sesuai dengan jenis tabungan dari nomor
        rekening yang sudah anda input sebelumnya.
      </p>
      <v-radio-group row v-model="tipeMerchant">
        <v-radio label="Individu" value="1" />
        <v-radio label="Badan Usaha" value="2" />
      </v-radio-group>
      <v-row align="center">
        <v-btn
          small
          color="warning"
          @click="prevStep"
          :style="{ margin: '2px' }"
        >
          <v-icon dark left> mdi-arrow-left </v-icon>Kembali
        </v-btn>
        <v-btn
          small
          color="primary"
          @click="nextStep"
          :style="{ margin: '2px' }"
        >
          Lanjut
          <v-icon dark right> mdi-arrow-right </v-icon>
        </v-btn>
      </v-row>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'step2',
  computed: {
    tipeMerchant: {
      set(val) {
        this.$store.commit('register/setAccountType', val);
      },
      get() {
        return this.$store.state.register.data.accountType;
      },
    },
  },
  methods: {
    prevStep() {
      this.$store.commit('register/setStep', 1);
    },
    nextStep() {
      this.$store.commit('register/setStep', 3);
    },
  },
};
</script>
